import UserRepresentation from '@keycloak/keycloak-admin-client/lib/defs/userRepresentation';
import { userStatusArr } from '@/config/constants';

export const ROLE_LIST = ['SUPERADMIN', 'MANUFACTURER_ADMIN', 'PARTNER_USER'];

export const ROLE_LIST_NAME = {
  SUPERADMIN: 'Super Admin',
  MANUFACTURER_ADMIN: 'Manufacturer Admin',
  PARTNER_USER: 'Partner User',
};

export const KC_ROLE = {
  'Super Admin': 'SUPERADMIN',
  'Manufacturer Admin': 'MANUFACTURER_ADMIN',
  'Partner User': 'PARTNER_USER',
};

export const KC_STATE = {
  DISABLED: 'DISABLED',
  DELETED: 'DELETED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  ACTIVE: 'ACTIVE',
};

export const KC_STATE_STATUS = {
  DISABLED: 'inactive',
  PENDING: 'pending',
  APPROVED: 'approved',
  ACTIVE: 'active',
};

export type UserRegisterParams = {
  username?: string;
  role?: string;
  mnId?: string[];
  purpose?: string;
  email?: string;
  division?: string;
};

export type UserManagementData = UserRepresentation & {
  role: string;
  status: typeof userStatusArr[number];
  division?: string;
};

export type ManufacturerAdminData = {
  email: string;
  mnid: string[];
};

export type UsedManufacturerMapping = {
  [email: string]: ManufacturerAdminData;
};

export type KeycloakAccessToken = {
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token?: string;
  refresh_token_expires_in?: number;
  session_state?: string;
  scope?: string;
};

export type KeycloakUserDetails = {
  sub?: string;
  name?: string;
  given_name?: string;
  family_name?: string;
  preferred_username?: string;
  email?: string;
  email_verified?: boolean;
  realm_access?: {
    roles: string[];
  };
  resource_access?: {
    [client_name: string]: {
      roles: string[];
    };
  };
  scope?: string;
  username?: string;
  active?: boolean;
};

export type UserRegisAttribute = {
  preferred_role?: string[];
  preferred_mnid?: string[];
  pic_email?: string[];
  purpose_to_use?: string[];
};

export type UserActiveAttribute = {
  mnid?: string[];
  direct_project?: string[];
  mobile_project?: string[];
  pic_email?: string[];
  role?: string[];
  reason_to_reject?: string[];
  reason_to_inactive?: string[];
  purpose_to_use?: string[];
};
